export default {
  default: [
    {
      path: "/medewerker",
      name: "admins.table",
      component: () => import("./views/AdminsTableView.vue"),
    },
    {
      path: "/medewerker/aanmaken",
      name: "admins.create",
      component: () => import("./views/AdminFormView.vue"),
    },
    {
      path: "/medewerker/:id",
      name: "admins.view",
      component: () => import("./views/AdminDetailsView.vue"),
    },
    {
      path: "/medewerker/:id/wijzigen",
      name: "admins.edit",
      component: () => import("./views/AdminFormView.vue"),
    },
  ],
};
